import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UsecasesComponent } from './usecases/usecases.component';

const routes: Routes = [
  {
    path: '',
    component: UsecasesComponent,
    data: {
      title: 'Use Case',
      urls: [{ title: 'Dashboard', url: '/' }, { title: 'Use Case' }],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsecaseRoutingModule {}
